const translations = {
  lv: {
    nav: {
      home: "Sākums",
      calculator: "Kalkulators",
      gallery: "Galerija",
      contact: "Kontakti",
      login: "Pieteikties",
      logout: "Iziet",
      myProjects: "Mani projekti",
      comparison: "Salīdzinājums",
      calendar: "Kalendārs",
      faq: "FAQ",
    },
    hero: {
      label: "Profesionāla renovācija Latvijā",
      title: "REMONTS BEZ\nKOMPROMISIEM",
      subtitle: "Aprēķiniet renovācijas izmaksas reāllaikā. Latvijas celtniecības pakalpojumi – vienā vietā.",
      cta: "Sākt kalkulāciju",
      requestQuote: "Pieprasīt tāmi",
    },
    features: {
      title: "KĀPĒC RMD?",
      f1t: "Caurspīdīgas cenas",
      f1d: "Reāllaika cenu aprēķins ar materiālu cenām no Latvijas lielākajiem veikaliem.",
      f2t: "Ātra tāme",
      f2d: "Iegūstiet detalizētu tāmi dažu minūšu laikā, bez gaidīšanas.",
      f3t: "Profesionāli darbi",
      f3d: "Pieredzējusi komanda ar garantiju uz visiem paveiktajiem darbiem.",
    },
    howItWorks: {
      title: "KĀ TAS DARBOJAS",
      s1t: "1. Izvēlies darbus",
      s1d: "Atzīmē nepieciešamos remontdarbus vai materiālus no 4 kategorijām.",
      s2t: "2. Ievadi izmērus",
      s2d: "Norādi platības (m²), garumu (m) vai skaitu.",
      s3t: "3. Saņem tāmi",
      s3d: "Iegūsti detalizētu PDF tāmi vai nosūti to uz e-pastu.",
    },
    testimonials: {
      title: "KLIENTU ATSAUKSMES",
    },
    gallery: {
      title: "MŪSU DARBI",
      subtitle: "Daži no mūsu paveiktajiem projektiem",
      viewAll: "Skatīt visus",
    },
    cta: {
      title: "GATAVS SĀKT?",
      subtitle: "Aprēķiniet renovācijas izmaksas jau tagad – bez maksas.",
      btn: "Atvērt kalkulatoru",
    },
    calculator: {
      title: "IZMAKSU KALKULATORS",
      subtitle: "Izvēlies vajadzīgos darbus un materiālus",
      tabs: {
        construction: "Būvdarbi",
        demolition: "Demolēšana",
        rental: "Noma",
        materials: "Būvmateriāli",
      },
      sidebar: {
        title: "JŪSU TĀME",
        projectName: "Projekta nosaukums",
        projectNamePlaceholder: "Piem. 'Dzīvokļa remonts'",
        areaTitle: "Dzīvokļa kopplatība (m²)",
        noItems: "Nav izvēlētu pozīciju",
        subtotal: "Starpsumma",
        total: "KOPĀ",
        vat: "* Nav iekļauts PVN 21%",
        timeline: "Aptuvenais laiks",
        weeks: "ned.",
        saveProject: "Saglabāt projektu",
        downloadPdf: "Lejupielādēt PDF",
        emailQuote: "Sūtīt uz e-pastu",
        requestQuote: "Pieprasīt tāmi",
      },
      qty: "Daudzums",
      unit_price: "Cena/vienību",
      subtotal: "Starpsumma",
      addItem: "Pievienot",
      storeTitle: "Cenas no veikaliem",
      selectStore: "Izvēlēties veikalu",
      cheapest: "Izdevīgākais",
    },
    gallery_page: {
      title: "MŪSU DARBI",
      subtitle: "Profesionāli izpildīti renovācijas projekti visā Latvijā",
      categories: ["Visi", "Virtuve", "Vannas istaba", "Dzīvojamā istaba", "Guļamistaba", "Kāpņu telpa"],
    },
    contact: {
      title: "KONTAKTI",
      subtitle: "Sazinies ar mums jebkurā laikā",
      address: "Adrese",
      addressVal: "Cēsis, Latvija",
      phone: "Tālrunis",
      email: "E-pasts",
      workHours: "Darba laiks",
      workHoursVal: "P.-Pk. 8:00 – 18:00",
      whatsapp: "WhatsApp",
      formTitle: "SŪTĪT ZIŅOJUMU",
      name: "Vārds",
      namePlaceholder: "Jūsu vārds",
      emailPlaceholder: "jūsu@epasts.lv",
      phonePlaceholder: "+371 XXXXXXXX",
      message: "Ziņojums",
      messagePlaceholder: "Aprakstiet savu projektu...",
      send: "Nosūtīt",
      success: "Ziņojums nosūtīts!",
    },
    auth: {
      loginTitle: "PIETEIKTIES",
      registerTitle: "REĢISTRĒTIES",
      email: "E-pasts",
      password: "Parole",
      passwordHint: "Minimāli 8 simboli (2 burti + 1 cipars)",      passwordConfirmError: "Paroles nesakrīt",      name: "Vārds",
      login: "Ieiet",
      register: "Reģistrēties",
      switchToRegister: "Nav konta? Reģistrēties",
      switchToLogin: "Jau ir konts? Ieiet",
      saveInfo: "Pieteikties, lai saglabātu projektu",
      error: "Kļūda",
    },
    quote: {
      title: "PIEPRASĪT TĀMI",
      subtitle: "Aizpildiet veidlapu un mēs ar jums sazināsimies",
      name: "Vārds, uzvārds",
      email: "E-pasts",
      phone: "Tālrunis",
      projectName: "Projekta nosaukums",
      notes: "Papildu piezīmes",
      notesPlaceholder: "Aprakstiet savu projektu vai jautājumus...",
      download: "Lejupielādēt PDF",
      send: "Sūtīt uz e-pastu",
      success: "Tāme nosūtīta uz e-pastu!",
      generating: "Ģenerē...",
    },
    common: {
      loading: "Ielādē...",
      error: "Kļūda",
      close: "Aizvērt",
      back: "Atpakaļ",
      save: "Saglabāt",
      cancel: "Atcelt",
      currency: "€",
    },
    calendar: {
      title: "KALENDĀRS",
      subtitle: "Izvēlieties datumu konsultācijai vai darbu uzsākšanai",
      available: "Pieejams",
      busy: "Aizņemts",
      weekend: "Brīvdiena",
      full: "Pilns",
      bookTitle: "PIETEIKT VIZĪTI",
      name: "Vārds, uzvārds",
      email: "E-pasts",
      phone: "Tālrunis",
      type: "Vizītes veids",
      consultation: "Konsultācija (bezmaksas)",
      work: "Darbu uzsākšana",
      message: "Papildu informācija",
      messagePlaceholder: "Aprakstiet savu projektu vai jautājumus...",
      submit: "Apstiprināt rezervāciju",
      success: "Rezervācija apstiprināta!",
      past: "Pagātne",
      today: "Šodien",
    },
    projects: {
      title: "MANI PROJEKTI",
      subtitle: "Jūsu saglabātie renovācijas projekti",
      empty: "Nav saglabātu projektu",
      emptyDesc: "Izveidojiet tāmi kalkulatorā un saglabājiet to šeit",
      deleteConfirm: "Vai tiešām vēlaties dzēst šo projektu?",
      deleted: "Projekts dzēsts",
      goCalc: "Atvērt kalkulatoru",
      items: "pozīcijas",
      loginRequired: "Pieteikties, lai redzētu savus projektus",
    }
  },

  ru: {
    nav: {
      home: "Главная",
      calculator: "Калькулятор",
      gallery: "Галерея",
      contact: "Контакты",
      login: "Войти",
      logout: "Выйти",
      myProjects: "Мои проекты",
      comparison: "Сравнение",
      calendar: "Календарь",
      faq: "FAQ",
    },
    hero: {
      label: "Профессиональный ремонт в Латвии",
      title: "РЕМОНТ БЕЗ\nКОМПРОМИССОВ",
      subtitle: "Рассчитайте стоимость ремонта в реальном времени. Строительные услуги Латвии — в одном месте.",
      cta: "Открыть калькулятор",
      requestQuote: "Запросить смету",
    },
    features: {
      title: "ПОЧЕМУ RMD?",
      f1t: "Прозрачные цены",
      f1d: "Расчёт стоимости в реальном времени с ценами из крупнейших магазинов Латвии.",
      f2t: "Быстрая смета",
      f2d: "Получите детальную смету за несколько минут, без ожидания.",
      f3t: "Профессиональные работы",
      f3d: "Опытная команда с гарантией на все выполненные работы.",
    },
    howItWorks: {
      title: "КАК ЭТО РАБОТАЕТ",
      s1t: "1. Выбери работы",
      s1d: "Отметьте необходимые ремонтные работы или материалы из 4 категорий.",
      s2t: "2. Введи размеры",
      s2d: "Укажите площадь (м²), длину (м) или количество.",
      s3t: "3. Получи смету",
      s3d: "Скачайте подробную PDF-смету или отправьте её на e-mail.",
    },
    testimonials: { title: "ОТЗЫВЫ КЛИЕНТОВ" },
    gallery: {
      title: "НАШИ РАБОТЫ",
      subtitle: "Некоторые из наших выполненных проектов",
      viewAll: "Смотреть все",
    },
    cta: {
      title: "ГОТОВ НАЧАТЬ?",
      subtitle: "Рассчитайте стоимость ремонта прямо сейчас — бесплатно.",
      btn: "Открыть калькулятор",
    },
    calculator: {
      title: "КАЛЬКУЛЯТОР СТОИМОСТИ",
      subtitle: "Выберите нужные работы и материалы",
      tabs: {
        construction: "Строительство",
        demolition: "Демонтаж",
        rental: "Аренда",
        materials: "Материалы",
      },
      sidebar: {
        title: "ВАША СМЕТА",
        projectName: "Название проекта",
        projectNamePlaceholder: "Напр. 'Ремонт квартиры'",
        areaTitle: "Общая площадь квартиры (м²)",
        noItems: "Нет выбранных позиций",
        subtotal: "Промежуточный итог",
        total: "ИТОГО",
        vat: "* НДС 21% не включён",
        timeline: "Примерное время",
        weeks: "нед.",
        saveProject: "Сохранить проект",
        downloadPdf: "Скачать PDF",
        emailQuote: "Отправить на e-mail",
        requestQuote: "Запросить смету",
      },
      qty: "Количество",
      unit_price: "Цена/ед.",
      subtotal: "Итого",
      storeTitle: "Цены в магазинах",
      cheapest: "Выгоднее всего",
    },
    gallery_page: {
      title: "НАШИ РАБОТЫ",
      subtitle: "Профессионально выполненные проекты по всей Латвии",
      categories: ["Все", "Кухня", "Ванная", "Гостиная", "Спальня", "Подъезд"],
    },
    contact: {
      title: "КОНТАКТЫ",
      subtitle: "Свяжитесь с нами в любое время",
      address: "Адрес",
      addressVal: "Цесис, Латвия",
      phone: "Телефон",
      email: "E-mail",
      workHours: "Рабочие часы",
      workHoursVal: "Пн.–Пт. 8:00 – 18:00",
      whatsapp: "WhatsApp",
      formTitle: "ОТПРАВИТЬ СООБЩЕНИЕ",
      name: "Имя",
      namePlaceholder: "Ваше имя",
      emailPlaceholder: "ваш@email.lv",
      phonePlaceholder: "+371 XXXXXXXX",
      message: "Сообщение",
      messagePlaceholder: "Опишите ваш проект...",
      send: "Отправить",
      success: "Сообщение отправлено!",
    },
    auth: {
      loginTitle: "ВОЙТИ",
      registerTitle: "РЕГИСТРАЦИЯ",
      email: "E-mail",
      password: "Пароль",
      passwordHint: "Минимум 8 символов (2 буквы + 1 цифра)",
      passwordConfirmError: "Пароли не совпадают",
      name: "Имя",
      login: "Войти",
      register: "Зарегистрироваться",
      switchToRegister: "Нет аккаунта? Зарегистрироваться",
      switchToLogin: "Уже есть аккаунт? Войти",
      saveInfo: "Войдите, чтобы сохранить проект",
      error: "Ошибка",
    },
    quote: {
      title: "ЗАПРОСИТЬ СМЕТУ",
      subtitle: "Заполните форму и мы свяжемся с вами",
      name: "Имя, фамилия",
      email: "E-mail",
      phone: "Телефон",
      projectName: "Название проекта",
      notes: "Дополнительные заметки",
      notesPlaceholder: "Опишите ваш проект или вопросы...",
      download: "Скачать PDF",
      send: "Отправить на e-mail",
      success: "Смета отправлена на e-mail!",
      generating: "Генерирует...",
    },
    common: {
      loading: "Загрузка...",
      error: "Ошибка",
      close: "Закрыть",
      back: "Назад",
      save: "Сохранить",
      cancel: "Отмена",
      currency: "€",
    },
    calendar: {
      title: "КАЛЕНДАРЬ",
      subtitle: "Выберите дату для консультации или начала работ",
      available: "Доступно",
      busy: "Занято",
      weekend: "Выходной",
      full: "Занято",
      bookTitle: "ЗАПИСАТЬСЯ",
      name: "Имя, фамилия",
      email: "E-mail",
      phone: "Телефон",
      type: "Тип визита",
      consultation: "Консультация (бесплатно)",
      work: "Начало работ",
      message: "Дополнительная информация",
      messagePlaceholder: "Опишите ваш проект...",
      submit: "Подтвердить бронирование",
      success: "Бронирование подтверждено!",
      past: "Прошло",
      today: "Сегодня",
    },
    projects: {
      title: "МОИ ПРОЕКТЫ",
      subtitle: "Ваши сохранённые проекты ремонта",
      empty: "Нет сохранённых проектов",
      emptyDesc: "Создайте смету в калькуляторе и сохраните её здесь",
      deleteConfirm: "Вы уверены, что хотите удалить этот проект?",
      deleted: "Проект удалён",
      goCalc: "Открыть калькулятор",
      items: "позиций",
      loginRequired: "Войдите, чтобы увидеть свои проекты",
    }
  },

  en: {
    nav: {
      home: "Home",
      calculator: "Calculator",
      gallery: "Gallery",
      contact: "Contact",
      login: "Login",
      logout: "Logout",
      myProjects: "My Projects",
      comparison: "Comparison",
      calendar: "Calendar",
      faq: "FAQ",
    },
    hero: {
      label: "Professional Renovation in Latvia",
      title: "RENOVATION WITHOUT\nCOMPROMISE",
      subtitle: "Calculate renovation costs in real time. Latvia's construction services — all in one place.",
      cta: "Start Calculating",
      requestQuote: "Request Quote",
    },
    features: {
      title: "WHY RMD?",
      f1t: "Transparent Pricing",
      f1d: "Real-time cost estimates with material prices from Latvia's largest stores.",
      f2t: "Fast Estimates",
      f2d: "Get a detailed quote in minutes, no waiting required.",
      f3t: "Professional Work",
      f3d: "Experienced team with a guarantee on all completed work.",
    },
    howItWorks: {
      title: "HOW IT WORKS",
      s1t: "1. Choose Services",
      s1d: "Select required renovation work or materials from 4 categories.",
      s2t: "2. Enter Dimensions",
      s2d: "Specify area (m²), length (m) or count.",
      s3t: "3. Get Your Quote",
      s3d: "Download a detailed PDF quote or send it to your email.",
    },
    testimonials: { title: "CLIENT TESTIMONIALS" },
    gallery: {
      title: "OUR WORK",
      subtitle: "Some of our completed renovation projects",
      viewAll: "View All",
    },
    cta: {
      title: "READY TO START?",
      subtitle: "Calculate your renovation costs now — for free.",
      btn: "Open Calculator",
    },
    calculator: {
      title: "COST CALCULATOR",
      subtitle: "Select required work and materials",
      tabs: {
        construction: "Construction",
        demolition: "Demolition",
        rental: "Rental",
        materials: "Materials",
      },
      sidebar: {
        title: "YOUR ESTIMATE",
        projectName: "Project Name",
        projectNamePlaceholder: "E.g. 'Apartment Renovation'",
        areaTitle: "Total Apartment Area (m²)",
        noItems: "No items selected",
        subtotal: "Subtotal",
        total: "TOTAL",
        vat: "* VAT 21% not included",
        timeline: "Estimated Time",
        weeks: "wks",
        saveProject: "Save Project",
        downloadPdf: "Download PDF",
        emailQuote: "Send by Email",
        requestQuote: "Request Quote",
      },
      qty: "Quantity",
      unit_price: "Price/unit",
      subtotal: "Subtotal",
      storeTitle: "Store Prices",
      cheapest: "Best Price",
    },
    gallery_page: {
      title: "OUR WORK",
      subtitle: "Professionally completed renovation projects across Latvia",
      categories: ["All", "Kitchen", "Bathroom", "Living Room", "Bedroom", "Stairway"],
    },
    contact: {
      title: "CONTACT",
      subtitle: "Get in touch with us at any time",
      address: "Address",
      addressVal: "Cēsis, Latvia",
      phone: "Phone",
      email: "Email",
      workHours: "Working Hours",
      workHoursVal: "Mon–Fri 8:00 – 18:00",
      whatsapp: "WhatsApp",
      formTitle: "SEND A MESSAGE",
      name: "Name",
      namePlaceholder: "Your name",
      emailPlaceholder: "your@email.com",
      phonePlaceholder: "+371 XXXXXXXX",
      message: "Message",
      messagePlaceholder: "Describe your project...",
      send: "Send",
      success: "Message sent!",
    },
    auth: {
      loginTitle: "LOGIN",
      registerTitle: "REGISTER",
      email: "Email",
      password: "Password",
      passwordHint: "Minimum 8 characters (2 letters + 1 number)",
      passwordConfirmError: "Passwords do not match",
      name: "Name",
      login: "Login",
      register: "Register",
      switchToRegister: "No account? Register",
      switchToLogin: "Have an account? Login",
      saveInfo: "Login to save your project",
      error: "Error",
    },
    quote: {
      title: "REQUEST QUOTE",
      subtitle: "Fill in the form and we'll get back to you",
      name: "Full Name",
      email: "Email",
      phone: "Phone",
      projectName: "Project Name",
      notes: "Additional Notes",
      notesPlaceholder: "Describe your project or questions...",
      download: "Download PDF",
      send: "Send by Email",
      success: "Quote sent to your email!",
      generating: "Generating...",
    },
    common: {
      loading: "Loading...",
      error: "Error",
      close: "Close",
      back: "Back",
      save: "Save",
      cancel: "Cancel",
      currency: "€",
    },
    calendar: {
      title: "CALENDAR",
      subtitle: "Choose a date for consultation or work start",
      available: "Available",
      busy: "Busy",
      weekend: "Weekend",
      full: "Full",
      bookTitle: "BOOK A VISIT",
      name: "Full Name",
      email: "Email",
      phone: "Phone",
      type: "Visit type",
      consultation: "Consultation (free)",
      work: "Work start",
      message: "Additional info",
      messagePlaceholder: "Describe your project...",
      submit: "Confirm booking",
      success: "Booking confirmed!",
      past: "Past",
      today: "Today",
    },
    projects: {
      title: "MY PROJECTS",
      subtitle: "Your saved renovation projects",
      empty: "No saved projects",
      emptyDesc: "Create an estimate in the calculator and save it here",
      deleteConfirm: "Are you sure you want to delete this project?",
      deleted: "Project deleted",
      goCalc: "Open Calculator",
      items: "items",
      loginRequired: "Login to see your projects",
    }
  }
};

export default translations;
